import * as React from 'react';
import {View} from "react-native";
import {DebugUrlOtp} from "../debug/DebugUrlOtp";

export const DebugScreen = () => {
    return (
        <View style={{margin: 20}}>
            <DebugUrlOtp />
        </View>
    );
};
